export default "__VITE_ASSET__115ec0ae__"